<template>
	<div>
		<div>
			<template>
				<div class="table_title">扫码版游戏配置</div>

				<div class="table_toolbar">
					<el-form :inline="true" :model="param.params" label-width="auto">
						<el-form-item label="状态">
							<el-select v-model="param.params.type">
								<el-option label="全部" value="0"></el-option>
								<el-option label="上架" value="1"></el-option>
								<el-option label="下架" value="2"></el-option>
							</el-select>
						</el-form-item>

						<el-form-item label="游戏名">
							<el-input
								v-model="param.params.search"
								placeholder="请输入游戏名称"
							></el-input>
						</el-form-item>

						<el-form-item>
							<el-button
								type="goon"
								icon="el-icon-search"
								@click="search()"
							></el-button>
						</el-form-item>
					</el-form>

					<el-button type="danger" icon="el-icon-plus" @click="addGame()"
						>添加游戏</el-button
					>
				</div>

				<el-table
					class="tableBox"
					style="height: 100%"
					:header-cell-style="{
						background: '#F1F6F9',
						color: '#606266',
						width: '100%',
					}"
					:data="tableData"
					border
				>
					<el-table-column
						label="游戏ID"
						prop="other_p_id"
						align="center"
					></el-table-column>

					<el-table-column
						label="游戏名"
						prop="product_name"
						align="center"
					></el-table-column>

					<el-table-column
						label="价格"
						prop="product_price"
						align="center"
					></el-table-column>

					<el-table-column
						label="有效期"
						prop="expired_time_hours"
						align="center"
					></el-table-column>

					<el-table-column label="状态" align="center">
						<template slot-scope="scope">
							{{ scope.row.product_status === 0 ? "上架" : "下架" }}
						</template></el-table-column
					>

					<el-table-column label="操作" align="center">
						<template slot-scope="scope">
							<el-button
								type="goon"
								icon="el-icon-edit-outline"
								@click="
									addGameForm = { ...scope.row };
									addGameDialogVisible = true;
								"
								>编辑</el-button
							>
						</template>
					</el-table-column>

					<!-- <el-table-column label="经理分配" align="center" width="160">
              <template slot-scope="scope">
                <el-select
                  v-model="scope.row.value"
                  placeholder="请选择"
                  @change="optionManager"
                  v-if="scope.row.status == 0"
                >
                  <el-option
                    v-for="item in selectData"
                    :key="item.agent_number"
                    :label="item.agent_name"
                    :value="item.agent_number"
                  ></el-option>
                </el-select>

                <span v-else>{{scope.row.agent_number}}</span>
              </template>
            </el-table-column> -->
				</el-table>
			</template>
		</div>
		<div style="text-align: right">
			<el-pagination
				background
				layout="prev, pager, next"
				:page-size="param.params.page_size"
				:total="total"
				@current-change="handleCurrentChange"
			></el-pagination>
		</div>
		<el-dialog
			title="增加游戏"
			:visible.sync="addGameDialogVisible"
			width="400px"
		>
			<el-form
				:model="addGameForm"
				ref="addGameForm"
				label-width="60px"
				:rules="rules"
			>
				<el-form-item label="游戏" prop="product_name">
					<el-select
						v-model="addGameForm.product_name"
						filterable
						remote
						reserve-keyword
						placeholder="请输入关键词"
						:remote-method="remoteMethod"
						:loading="xubeiGameLoading"
						@change="handleSelectChange"
					>
						<el-option
							v-for="item in xubeiGameData"
							:key="item.product_id + '-' + item.game_id"
							:label="item.product_name"
							:value="item.product_name"
						>
						</el-option> </el-select
				></el-form-item>

				<el-form-item label="售价">
					<el-input-number
						v-model="addGameForm.product_price"
						:min="0.01"
						:max="100"
						:precision="2"
					/>
				</el-form-item>

				<el-form-item label="时长"
					><el-radio-group v-model="addGameForm.expired_time_hours">
						<el-radio :label="4">4小时</el-radio>
						<el-radio :label="8">8小时</el-radio>
					</el-radio-group></el-form-item
				>

				<el-form-item label="状态"
					><el-radio-group v-model="addGameForm.product_status">
						<el-radio :label="0">上架</el-radio>
						<el-radio :label="1">下架</el-radio>
					</el-radio-group></el-form-item
				>
			</el-form>

			<div slot="footer">
				<el-button @click="addGameDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="addGameSubmit('addGameForm')"
					>确定</el-button
				>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import * as sysApi from "../../common/sys";
import axios from "axios";

export default {
	data() {
		return {
			tableData: [],
			param: {
				params: {
					page: 1,
					page_size: 20,
					search: "",
					type: "0",
				},
			},
			initialValues: {
				product_name: "",
				product_status: 0,
				product_price: 1,
				expired_time_hours: 4,
				other_p_id: null,
				id: 0,
			},
			addGameForm: {},
			rules: {
				product_name: [
					{ required: true, message: "请选择先选择游戏", trigger: "change" },
				],
			},
			xubeiGameParams: {
				page: 1,
				pageSize: 5,
				service: "group",
				product_name: "",
				sort: "hot",
				origin: "ybjsqapi01",
			},
			xubeiGameLoading: false,
			xubeiGameData: [],
			total: null,
			addGameDialogVisible: false,
		};
	},
	created() {
		this.initQuery();
	},
	methods: {
		initQuery() {
			sysApi.qrcode_game_list(this.param).then((res) => {
				if (res.code != 200) {
					return this.$message.error(res.info);
				}
				this.tableData = res.list;
				this.total = res.sum_count;
			});
		},
		remoteMethod(query) {
			if (query !== "") {
				this.xubeiGameLoading = true;
				this.xubeiGameParams.product_name = query;

				axios
					.get("https://api.steamboxs.com/api/getProductList", {
						params: this.xubeiGameParams,
					})
					.then((res) => {
						if (res.status != 200) {
							return this.$message.error("获取游戏列表失败");
						}

						this.xubeiGameLoading = false;

						this.xubeiGameData = res.data.data.data;
					});
			} else {
				this.xubeiGameData = [];
			}
		},
		addGame() {
			this.addGameForm = { ...this.initialValues };
			this.addGameDialogVisible = true;
		},
		addGameSubmit(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					sysApi.qrcode_game_price_config(this.addGameForm).then((res) => {
						if (res.code != 200) {
							return this.$message.error(res.msg);
						}

						this.$message.success("操作成功");

						this.initQuery();

						this.addGameDialogVisible = false;
					});
				} else {
					return false;
				}
			});
		},
		handleSelectChange(value) {
			const selected = this.xubeiGameData.find(
				(item) => item.product_name === value
			);
			this.addGameForm.other_p_id = selected.product_id;
		},
		search() {
			this.initQuery();
		},
		// 分页
		handleCurrentChange(val) {
			this.param.params.page = val;
			this.initQuery();
		},
	},
};
</script>

<style scoped lang="scss">
.table_title {
	border: 1px solid #ebeef5;
	border-bottom: 0px;
	text-align: center;
	font-size: 18px;
	font-weight: bold;
	height: 49px;
	line-height: 49px;
	background: #f1f6f9;
	margin-bottom: 12px;
}

.table_toolbar {
	display: flex;
	justify-content: space-between;
	margin-bottom: 12px;
}

.el-form:not(.el-form--inline) .el-form-item {
	margin-bottom: 22px !important;
}
</style>
